import PartnershipDTO from "@/dto/partnership/PartnershipDTO";
import ShopType from "@/enum/ShopType";
import mainServerClient from "@/services/http/mainServerClient";
import { sortPartnership } from "@/utils/dropShipping";

interface UpdateRetailerAliasParams {
    partnershipId: number;
    retailerAlias: string;
}

/** 供货商修改代理商的昵称/别名 */
export function updateRetailerAlias(params: UpdateRetailerAliasParams) {
    return mainServerClient.post("/drop_shipping_partnership/update_retailer_alias", params);
}

/**
 * 取消合作
 */
export function suspended(id: number) {
    return mainServerClient.get(`/drop_shipping_partnership/suspended/${id}`);
}

/** 生成当前代理商的关联码 */
export function generatePartnerShipCode(shopId): Promise<string> {
    return mainServerClient.post("/drop_shipping_partnership/generate_partnership_code", { shopId });
}

interface FindRetailByPartnershipCodeResult {
    name: string;
    sellerUsername: string;
    shopId: number;
    shopType: ShopType;
}
/** 通过关联码获取代理商的信息 */
export function findRetailByPartnershipCode(code: string): Promise<FindRetailByPartnershipCodeResult> {
    return mainServerClient.get("/drop_shipping_partnership/get_retailer_shop_by_partnership_code", { code });
}

interface CreateDropshippingPartnerShipParams {
    partnershipCode: string;
}

/** 通过关联码关联代理商 */
export function createDropshippingPartnership(params: CreateDropshippingPartnerShipParams): Promise<void> {
    return mainServerClient.post("/drop_shipping_partnership/create", params);
}

export interface SupplierShopDTO {
    name: string;

    sellerUsername: string;

    shopType: ShopType;

    shopId: number;
}

interface UpdateRetailerNotesParams {
    partnershipId: number;
    supplierAlias: string;
}

/** 代理商修改供货商的昵称/别名 */
export function updateSupplierAlias(params: UpdateRetailerNotesParams): Promise<void> {
    return mainServerClient.post("/drop_shipping_partnership/update_supplier_alias", params);
}

/** 查看当前租户是否是分销代理商用户，用于前端ui显示相关 */
export function getIsRetailer(): Promise<boolean> {
    return mainServerClient.get("/drop_shipping_partnership/is_retailer");
}

/** 创建虚拟供货商 */
export function createDummySupplier(retailerShopId: number, dummySupplierName: string): Promise<void> {
    return mainServerClient.post("/drop_shipping_partnership/create_dummy_supplier", {
        retailerShopId,
        dummySupplierName,
    });
}

/** 与虚拟供货商重新建立合作 */
export function reestablishDummySupplier(supplierId: number): Promise<void> {
    return mainServerClient.get(`/drop_shipping_partnership/reestablish/${supplierId}`);
}

/** 根据代理商店铺ID获取该代理商对应所有的供货商合作关系（只会返回和参数匹配的平台类型） */
export async function getPartnershipsByRetailerShopId(retailerShopId: number) {
    const partnerships = await mainServerClient.get<PartnershipDTO[]>(
        "/drop_shipping_partnership/list_supplier_partnerships",
        {
            retailerShopId,
        },
    );

    partnerships.forEach((partnership) => {
        partnership._retailerShopId = retailerShopId;
    });

    return partnerships.sort(sortPartnership);
}

/** 获取与代理商关联一起的其他店铺的供货商合作关系（只会返回和参数匹配的平台类型） */
export async function getAssociatedShopPartnershipsByRetailerShopId(retailerShopId: number) {
    const partnerships = await mainServerClient.get<PartnershipDTO[]>(
        "/drop_shipping_partnership/list_associated_shop_supplier_partnerships",
        {
            retailerShopId,
        },
    );

    return partnerships.sort(sortPartnership);
}

/** 根据供货商店铺ID获取所有对应的代理商合作关系（只会返回和参数匹配的平台类型） */
export async function getPartnershipsBySupplierShopId(supplierShopId: number) {
    const partnerships = await mainServerClient.get<PartnershipDTO[]>(
        "/drop_shipping_partnership/list_retailer_partnerships",
        {
            supplierShopId,
        },
    );

    return partnerships.sort(sortPartnership);
}

interface PartnershipIndex {
    /**
     * 排序值/序号
     */
    index: number;
    /**
     * 合作关系ID
     */
    partnershipId: number;
}

interface UpdatePartnershipIndexParams {
    partnershipIndexList: PartnershipIndex[];
}

/** 更新代理商的合作关系排序 */
export function updateRetailerPartnershipIndex(params: UpdatePartnershipIndexParams): Promise<void> {
    return mainServerClient.post("/drop_shipping_partnership/update_retailer_index", params);
}

/** 更新供货商的合作关系排序 */
export function updateSupplierPartnershipIndex(params: UpdatePartnershipIndexParams): Promise<void> {
    return mainServerClient.post("/drop_shipping_partnership/update_supplier_index", params);
}

export function updateSupplierShippingAddress(partnershipId: number, shippingAddressId?: number): Promise<void> {
    return mainServerClient.post("/drop_shipping_partnership/update_shipping_address", {
        partnershipId,
        shippingAddressId,
    });
}
